export default {
    titleQuestion: "What can we help you with?",
    titleDescription: "Ask a question or describe a problem you're having",
    searchFaq: "Search FAQ",
    categories: "Categories",
    searchResults: "Search Results"
}
